<template>
  <v-row>
    <v-col md="3" cols="10">
      <v-text-field
        v-if="searchField"
        v-model="search"
        prepend-inner-icon="mdi-magnify"
        hide-details="auto"
        label="Search"
        outlined
        dense
        @input="$emit('updateSearch', search)"
      ></v-text-field>
    </v-col>
    <v-spacer></v-spacer>
    <v-col md="3" cols="2" class="d-flex justify-end px-0">
      <v-btn
        small
        v-if="addField"
        @click="$emit('add')"
        style="height: 40px"
        class="primary ml-2 mr-3"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-col>
    <v-col md="3" v-if="enableDownload" cols="2" class="d-flex justify-end px-0">
      <v-btn
        @click="$emit('download')"
        :disabled="!itemLength"
        class="accent white--text ml-2"
      >
        <v-icon>mdi-download</v-icon> Download
      </v-btn>
    </v-col>
    <v-dialog v-model="dialog" max-width="600px" persistent>
      <v-card>
        <v-card-title>Import {{ headerText }}</v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <!-- Left Side: File Input -->
              <v-col cols="12">
                <input
                  ref="fileInput"
                  type="file"
                  @change="handleFileUpload"
                  accept=".csv"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn
            rounded
            depressed
            outlined
            color="accent"
            @click="cancel()"
            :disabled="loading"
            >Cancel</v-btn
          >
          <v-btn
            rounded
            depressed
            outlined
            color="accent"
            :disabled="!selectedFile"
            @click="fileUpload"
            :loading="loading"
          >
            Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    searchField: {
      type: Boolean,
      default: true,
    },
    addField: {
      type: Boolean,
      default: true,
    },
    uploadField: {
      type: Boolean,
      default: true,
    },
    headerText: {
      type: String,
      default: "",
    },
    url: {
      type: String,
      default: "",
    },
    enableDownload: {
      type: Boolean,
      default: false,
    },
    itemLength: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      search: "",
      dialog: false,
      selectedFile: null,
      loading: false,
    };
  },
  methods: {
    handleFileUpload(event) {
      this.selectedFile = event;
    },
    cancel() {
      this.dialog = false;
      this.selectedFile = null;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }
    },

    async fileUpload() {
      this.loading = true;
      const { csvData, errorMessage } = await this.$store.dispatch(
        "handleFileUpload",
        this.selectedFile
      );
      if (errorMessage)
        return this.$store.commit("showSnackbar", {
          message: errorMessage,
          color: "error",
        });

      try {
        const filteredData = csvData.data.filter((data) => {
          return data.id && Object.keys(data).length === csvData.headers.length;
        });

        const response = await this.$axios.post(this.url, {
          data: filteredData,
          headers: csvData.headers,
        });

        // Check if there are errors (by checking if response is a CSV file)
        if (response.status === 201) {
          // Create a URL for the CSV file blob
          const url = window.URL.createObjectURL(new Blob([response.data]));

          // Create a temporary <a> element for downloading the file
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${this.headerText} Errors.csv`); // File name
          document.body.appendChild(link);
          link.click(); // Trigger the download
          document.body.removeChild(link);
        }

        if (response.status === 200) {
          this.$store.commit("showSnackbar", {
            message: "File imported successfully",
            color: "success",
          });
          this.cancel();
          this.$emit("fileUploaded");
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$store.commit("showSnackbar", {
          message: error.response.data.message,
          color: "error",
        });
      }
    },
  },
};
</script>
